import PageDataLoader from '../../../lib/page-data/loader';
import PageKey from '../../../lib/page-data/key';
import {
  MATCH_REPORTS_PAGE_REQUEST,
  MATCH_REPORTS_PAGE_RECEIVE,
  MATCH_REPORTS_PAGE_FAILURE,
  PAGE_DATA_LOAD,
} from '../../action-types';

export const fetchMatchReportsPageData = (clubId, teamId, request) => async (dispatch) => {
  try {
    dispatch({ type: MATCH_REPORTS_PAGE_REQUEST, payload: { clubId, teamId } });
    const pageKey = new PageKey(clubId, 'match_reports', { teamId });
    const pageData = await PageDataLoader.getPageData(pageKey, request);
    const { seasons, reports } = pageData.data;

    dispatch({
      type: MATCH_REPORTS_PAGE_RECEIVE,
      payload: { clubId, teamId, seasons, reports },
    });
    dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });

    return {};
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }
    dispatch({
      type: MATCH_REPORTS_PAGE_FAILURE,
      payload: { clubId, teamId, statusCode, error },
    });
    return { error };
  }
};
